import { Dialog } from "primereact/dialog";
import React, { useState } from "react";
import Edit from "../../../../Utils/SuperModal/SuperModal";

export default function EditMaster() {
  const [open, setOpen] = useState(false);

  const OpenEdit = () => {
    setOpen(true);
  };
  const CloseEdit = () => {
    setOpen(false);
  };

  window.openeditSuper = OpenEdit;
  window.closeeditSuper = CloseEdit;

  return (
    <div>
      <Dialog
        visible={open}
        closeOnEscape
        closeIcon
        onHide={CloseEdit}
        id="modal"
        position="center"
        transitionOptions={false}
        focusOnShow={false}
      >
        <Edit user_id={window.user_id} close={CloseEdit} />
      </Dialog>
    </div>
  );
}
